<!-- 토스트는 하나만 보임 -->
<template>
	<div class="toast_box">
		<div v-if="toastStore.toast.icon" class="toast_icon">
			<svg
				v-if="toastStore.toast.icon === 'alert'"
				xmlns="http://www.w3.org/2000/svg"
				viewBox="0 0 17 18"
				fill="#F41201"
			>
				<path
					d="M8.49992 17.0277C4.07192 17.0277 0.471924 13.4277 0.471924 8.99968C0.471924 4.57168 4.07192 0.97168 8.49992 0.97168C12.9279 0.97168 16.5279 4.57168 16.5279 8.99968C16.5279 13.4277 12.9279 17.0277 8.49992 17.0277ZM8.49992 2.43568C4.87592 2.43568 1.93592 5.38768 1.93592 8.99968C1.93592 12.6117 4.88792 15.5637 8.49992 15.5637C12.1119 15.5637 15.0639 12.6117 15.0639 8.99968C15.0639 5.38768 12.1119 2.43568 8.49992 2.43568Z"
				/>
				<path
					d="M8.49982 9.73156C8.09182 9.73156 7.76782 9.40756 7.76782 8.99956V6.08356C7.76782 5.67556 8.09182 5.35156 8.49982 5.35156C8.90782 5.35156 9.23182 5.67556 9.23182 6.08356V8.99956C9.23182 9.40756 8.90782 9.73156 8.49982 9.73156Z"
				/>
				<path
					d="M8.49982 12.6476C8.09182 12.6476 7.76782 12.3236 7.76782 11.9156C7.76782 11.5076 8.09182 11.1836 8.49982 11.1836C8.90782 11.1836 9.23182 11.5076 9.23182 11.9156C9.23182 12.3236 8.90782 12.6476 8.49982 12.6476Z"
				/>
			</svg>
			<svg
				v-else-if="toastStore.toast.icon === 'confirm'"
				xmlns="http://www.w3.org/2000/svg"
				viewBox="0 0 15 14"
				fill="#3870ff"
			>
				<path
					d="M7.5 13.6896C3.81 13.6896 0.809998 10.6896 0.809998 6.99957C0.809998 3.30957 3.81 0.30957 7.5 0.30957C11.19 0.30957 14.19 3.30957 14.19 6.99957C14.19 10.6896 11.19 13.6896 7.5 13.6896ZM7.5 1.52957C4.48 1.52957 2.03 3.98957 2.03 6.99957C2.03 10.0096 4.49 12.4696 7.5 12.4696C10.51 12.4696 12.97 10.0096 12.97 6.99957C12.97 3.98957 10.51 1.52957 7.5 1.52957Z"
				/>
				<path
					d="M7.44999 8.21937C7.19999 8.21937 6.96 8.05937 6.87 7.79937C6.76 7.47937 6.94 7.13937 7.25 7.02937C7.61 6.90937 8.66 6.40937 8.66 5.77937C8.66 5.48937 8.56 5.20937 8.37 4.98937C8.19 4.76937 7.93 4.61937 7.64 4.56937C7.36 4.51937 7.07 4.56937 6.82 4.71937C6.57 4.86937 6.38 5.08937 6.29 5.35937C6.18 5.67937 5.83 5.83937 5.51 5.72937C5.19 5.61937 5.03 5.26937 5.14 4.94937C5.33 4.40937 5.70999 3.94937 6.19999 3.65937C6.69999 3.36937 7.27999 3.25937 7.83999 3.35937C8.40999 3.45937 8.92 3.74937 9.29 4.18937C9.66 4.62937 9.86 5.18937 9.86 5.75937C9.86 7.36937 7.85 8.07937 7.62 8.15937C7.56 8.17937 7.49 8.18937 7.43 8.18937L7.44999 8.21937Z"
				/>
				<path
					d="M7.51 10.6497C7.17 10.6497 6.9 10.3797 6.9 10.0397C6.9 9.69969 7.17 9.42969 7.51 9.42969C7.85 9.42969 8.12 9.69969 8.12 10.0397C8.12 10.3797 7.85 10.6497 7.51 10.6497Z"
				/>
			</svg>
			<img v-else :src="toastStore.toast.icon" alt="icon" loading="lazy" />
		</div>
		<div class="toast_content">
			<p class="content">{{ toastStore.toast.subContent }}</p>
			<p class="content">{{ toastStore.toast.content }}</p>
		</div>
	</div>
</template>

<script setup lang="ts">
// core
import { onMounted, onUnmounted, ref, watch } from 'vue';

// store
import { useToastStore } from '@/stores/toast';

const toastStore = useToastStore();
const timeId = ref();

// 자동으로 showTime(기본값 3000) 이후에 닫히도록
onMounted(() => {
	timeId.value = setTimeout(() => {
		toastStore.closeToast();
	}, toastStore.toast.showTime ?? 3000);
});
// 토스트 중간에 또 열릴경우 showTime(기본값 3000) 초기화
watch(
	() => toastStore.toast,
	() => {
		clearTimeout(timeId.value);
		timeId.value = setTimeout(() => {
			toastStore.closeToast();
		}, toastStore.toast.showTime ?? 3000);
	}
);
onUnmounted(() => {
	clearTimeout(timeId.value);
});
</script>

<style scoped lang="scss">
.toast_box {
	z-index: 999;
	position: fixed;
	bottom: var(--space-x-large);
	left: 50%;
	transform: translateX(-50%);
	display: flex;
	align-items: center;
	gap: var(--space-x-small);
	width: 100%;
	max-width: min(calc(100vw - 4rem), 44.9rem); /* 40rem 이거나 최소한 양쪽에 2rem의 여백은 갖도록 */
	padding: var(--space-mid) var(--space-mid) 3.3rem var(--space-mid);
	border-radius: var(--border-radius-xx-small);
	background-color: #292a2d;
	box-shadow: 0 4px 4px rgba(0, 0, 0, 0.25);
	white-space: nowrap;
	@media screen and (max-width: 1280px) {
		padding: 1.6rem;
		width: unset;
	}
	.toast_icon {
		width: 1.8rem;
		height: 1.8rem;
		flex-shrink: 0;
	}
	.toast_content {
		flex-grow: 1;
		gap: 1.3rem;
		display: flex;
		flex-direction: column;
		@media screen and (max-width: 1280px) {
			gap: 0rem;
		}
		.content {
			font-weight: var(--font-w-regular);
			color: #e8eaed;
			font-size: 1.6rem;
			line-height: 1.875rem; /* 134.615% */
			letter-spacing: 2%;
		}
	}
}
</style>
